import * as React from 'react';

function SvgUser(props) {
  return (
    <svg width={20} height={20} fill="none" {...props}>
      <circle cx={10} cy={6.2} r={3.45} stroke={props.color} strokeWidth={1.5} />
      <path
        d="M3.82 15.126c.45-2.742 3.012-4.91 6.18-4.91 3.168 0 5.73 2.168 6.18 4.91a.062.062 0 01-.002.03.092.092 0 01-.021.034.218.218 0 01-.157.06H4a.218.218 0 01-.157-.06.09.09 0 01-.021-.033.063.063 0 01-.001-.031z"
        stroke={props.color}
        strokeWidth={1.5}
      />
    </svg>
  );
}

export default SvgUser;
